/** @jsx jsx */
import React, { useContext } from 'react'
import gql from 'graphql-tag'
import styled from '@emotion/styled'
import { jsx } from '@emotion/react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import A from '../../typography/A'
import ButtonSubmit from '../../buttons/ButtonSubmit'
import Form from '../inputs/Form'
import InputText from '../inputs/InputText'
import ModalForgotPassword from '../../modals/ModalForgotPassword'
import ModalRegisterForAccess from '../../modals/ModalRegisterForAccess'
import {
  useLoginFormMutation,
  GlobalContextProviderDocument,
} from '../../../generated/graphql'
import { ModalsContext } from '../../modals/Modals'
import { mq } from '../../../theme'
import { queryName } from '../../utils'

const SpanSmall = styled(A)(() => ({
  textDecoration: 'none',
}))

const mutation = gql`
  mutation LoginForm($data: String) {
    login(data: $data) {
      status
      formErrors
    }
  }
`

interface Props {
  buttonCss?: any
}

const LoginForm: React.FC<Props> = (props) => {
  const { buttonCss } = props
  const history = useHistory()
  const formCtx = useForm<any>()
  const modalsCtx = useContext(ModalsContext)

  const [mutate, { loading, data }] = useLoginFormMutation({
    // prettier-ignore
    refetchQueries: [queryName(GlobalContextProviderDocument), ],
    awaitRefetchQueries: true,
  })

  const onSuccess = () => {
    const {
      location: { search },
    } = history
    modalsCtx?.hide()
    if (search.indexOf('next=') > -1) {
      const redirect = search.replace('?next=', '')
      history.push(`/en${redirect}`)
      return
    }
    history.push('/en/u/')
  }

  if (!modalsCtx) {
    return null
  }

  return (
    <Form
      autoSubmitEnabled={false}
      centerMessages={true}
      dataLossWarningEnabled={false}
      formCtx={formCtx}
      mutate={mutate}
      mutationData={data}
      mutationName="login"
      onSuccess={onSuccess}
      errorMessage=""
    >
      <InputText
        label="Email"
        name="username"
        placeholder="Email"
        isRequired={true}
      />
      <InputText
        name="password"
        label="Password"
        placeholder="Password"
        type="password"
        isRequired={true}
        css={[mq('mb0.5')]}
      />

      <div css={[mq('text-right')]}>
        <SpanSmall
          onClick={() =>
            modalsCtx.show(
              <ModalForgotPassword size={800} title="Forgot Password" />
            )
          }
        >
          Forgot Your Password?
        </SpanSmall>
      </div>

      <div css={[mq('text-center'), mq('mt1')]}>
        <ButtonSubmit css={[buttonCss]} disabled={loading}>
          Login
        </ButtonSubmit>
      </div>
    </Form>
  )
}

export default LoginForm
